var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t)
    return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i)
        return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
} return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) {
    if ("string" == typeof r)
        return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
} }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++)
    n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) {
    var e, n, i, u, a = [], f = !0, o = !1;
    try {
        if (i = (t = t.call(r)).next, 0 === l) {
            if (Object(t) !== t)
                return;
            f = !1;
        }
        else
            for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0)
                ;
    }
    catch (r) {
        o = !0, n = r;
    }
    finally {
        try {
            if (!f && null != t.return && (u = t.return(), Object(u) !== u))
                return;
        }
        finally {
            if (o)
                throw n;
        }
    }
    return a;
} }
function _arrayWithHoles(r) { if (Array.isArray(r))
    return r; }
import React, { useMemo, useState } from 'react';
import { Button, Input, Select, Table, Form, Card, Space, Modal, message } from 'antd';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { LABEL_MAP_USER_STATUS, LABEL_MAP_PAYMENT_STATUS, OPTION_USER_STATUS_SELECT, OPTION_PAYMENT_STATUS_SELECT } from '../../contants/option';
import { exportLTVUsersSelected, fetchAdminDiagnosisIcons, fetchAdminUserList, fetchLTVUsers, formatLtvAsyncExportMessage, updateAdminUserDiagnosisResult } from '../../cores/api/api-dashboard';
import { usePagination } from '../../cores/hooks/use-pagination';
import { useTableSearchParams } from '../../cores/hooks/use-search-param';
import { filterAllowedParams } from '../../utils/utils';
import dayjs from 'dayjs';
import CreatedDateFilter from '../../dashboard/components/filter/date-filter';
const Option = Select.Option;
const ASYNC_EXPORT_MAX_ROWS = 5000;
const ALLOW_FILTER_KEYS = ['page', 'limit', 'sex', 'status', 'payment_confirmation', 'email', 'age_min', 'age_max', 'from_date', 'to_date', 'sort_by', 'order'];
export default function UserPaymentPage() {
    var _a, _b;
    const _Form$useForm = Form.useForm(), _Form$useForm2 = _slicedToArray(_Form$useForm, 1), form = _Form$useForm2[0];
    const queryClient = useQueryClient();
    const _useState = useState(null), _useState2 = _slicedToArray(_useState, 2), diagnosisModalUser = _useState2[0], setDiagnosisModalUser = _useState2[1];
    const _useState3 = useState(null), _useState4 = _slicedToArray(_useState3, 2), diagnosisSelectValue = _useState4[0], setDiagnosisSelectValue = _useState4[1];
    const _useState5 = useState(false), _useState6 = _slicedToArray(_useState5, 2), isCsvModalOpen = _useState6[0], setIsCsvModalOpen = _useState6[1];
    const _useState7 = useState(''), _useState8 = _slicedToArray(_useState7, 2), csvEmail = _useState8[0], setCsvEmail = _useState8[1];
    const _useState9 = useState(false), _useState0 = _slicedToArray(_useState9, 2), isCsvSubmitting = _useState0[0], setIsCsvSubmitting = _useState0[1];
    const _useState1 = useState(false), _useState10 = _slicedToArray(_useState1, 2), isCsvExporting = _useState10[0], setIsCsvExporting = _useState10[1];
    const _useTableSearchParams = useTableSearchParams({
        page: 1,
        limit: 20
    }), params = _useTableSearchParams.params, updateFilter = _useTableSearchParams.updateFilter, handleTableChange = _useTableSearchParams.handleTableChange;
    const _useQuery = useQuery({
        queryKey: ['admin-payment-users', filterAllowedParams(params, ALLOW_FILTER_KEYS)],
        queryFn: () => fetchAdminUserList(filterAllowedParams(params, ALLOW_FILTER_KEYS)),
        keepPreviousData: true
    }), data = _useQuery.data, isLoading = _useQuery.isLoading, isFetching = _useQuery.isFetching;
    const pagination = usePagination(data === null || data === void 0 ? void 0 : data.data.pagination, 20);
    const dataSource = (_a = data === null || data === void 0 ? void 0 : data.data.users) !== null && _a !== void 0 ? _a : [];
    const ltvExportCountParams = useMemo(() => {
        const requestParams = params;
        return {
            page: 1,
            limit: 1,
            sex: requestParams.sex,
            email: requestParams.email,
            sort_by: requestParams.sort_by,
            order: requestParams.order
        };
    }, [params.sex, params.email, params.sort_by, params.order]);
    const _useQuery2 = useQuery({
        queryKey: ['admin-user-ltvs-export-count', ltvExportCountParams],
        queryFn: () => fetchLTVUsers(ltvExportCountParams),
        keepPreviousData: true
    }), ltvExportMeta = _useQuery2.data;
    const _useQuery3 = useQuery({
        queryKey: ['admin-diagnosis-icons', 'user-assign'],
        queryFn: () => fetchAdminDiagnosisIcons({
            per_page: 100,
            active: true
        }),
        enabled: diagnosisModalUser !== null
    }), diagnosisIconsRes = _useQuery3.data;
    const diagnosisMutation = useMutation({
        mutationFn: ({ userId, resultId }) => updateAdminUserDiagnosisResult(userId, resultId),
        onSuccess: res => {
            if (!res.success) {
                if (res.statusCode === 401)
                    message.error('管理者ログインが必要です');
                else if (res.error === 'inactive_master')
                    message.error('非アクティブなアイコンは割り当てできません');
                else
                    message.error('更新に失敗しました');
                return;
            }
            message.success('診断アイコンを更新しました');
            queryClient.invalidateQueries({
                queryKey: ['admin-payment-users']
            });
            setDiagnosisModalUser(null);
        },
        onError: () => message.error('更新に失敗しました')
    });
    const openDiagnosisModal = user => {
        var _a;
        setDiagnosisModalUser(user);
        setDiagnosisSelectValue((_a = user.sexual_desire_diagnosis_result_id) !== null && _a !== void 0 ? _a : null);
    };
    const diagnosisOptions = (_b = diagnosisIconsRes === null || diagnosisIconsRes === void 0 ? void 0 : diagnosisIconsRes.data) !== null && _b !== void 0 ? _b : [];
    const userColumns = [{
            title: 'ユーザーID',
            dataIndex: 'id',
            key: 'id',
            width: 120,
            render: (_, record) => /*#__PURE__*/ React.createElement("a", {
                href: `/userpage?id=${record.id}`,
                target: "_blank",
                className: "text-blue-600 hover:underline text-[12px]"
            }, record.id),
            sorter: true,
            sortOrder: params.sort_by === 'id' ? params.order === 'asc' ? 'ascend' : 'descend' : undefined
        }, {
            title: 'Twitter Id',
            dataIndex: 'twitterid',
            key: 'twitterid',
            width: 160,
            sorter: true,
            sortOrder: params.sort_by === 'twitterid' ? params.order === 'asc' ? 'ascend' : 'descend' : undefined,
            render: (_, record) => /*#__PURE__*/ React.createElement("a", {
                href: `/userpage?id=${record.id}`,
                target: "_blank",
                className: "text-blue-600 hover:underline text-[12px]"
            }, "@", record.twitterid)
        }, {
            title: 'Twitter名',
            dataIndex: 'twitter_name',
            key: 'twitter_name',
            width: 200,
            sorter: true,
            sortOrder: params.sort_by === 'twitter_name' ? params.order === 'asc' ? 'ascend' : 'descend' : undefined
        }, {
            title: 'メールアドレス',
            dataIndex: 'email',
            key: 'email',
            sorter: true,
            sortOrder: params.sort_by === 'email' ? params.order === 'asc' ? 'ascend' : 'descend' : undefined
        }, {
            title: '年齢',
            dataIndex: 'age',
            key: 'age',
            width: 80,
            align: 'center',
            sorter: true
        }, {
            title: '性別',
            dataIndex: 'sex_text',
            key: 'sex_text',
            width: 100,
            align: 'center'
        }, {
            title: 'ユーザステータス',
            dataIndex: 'status',
            key: 'status',
            width: 140,
            align: 'center',
            render: v => { var _a; return (_a = LABEL_MAP_USER_STATUS[v]) !== null && _a !== void 0 ? _a : '未設定'; }
        }, {
            title: '会員ステータス',
            dataIndex: 'payment_confirmation',
            key: 'payment_confirmation',
            width: 230,
            render: v => { var _a; return (_a = LABEL_MAP_PAYMENT_STATUS[v]) !== null && _a !== void 0 ? _a : 'データなし'; }
        }, {
            title: '診断アイコン',
            key: 'sexual_desire_diagnosis_result',
            width: 160,
            render: (_, record) => /*#__PURE__*/ {
                var _a;
                return React.createElement("div", {
                    className: "flex flex-col gap-1 items-start"
                }, ((_a = record.sexual_desire_diagnosis_result) === null || _a === void 0 ? void 0 : _a.image_url) ? /*#__PURE__*/ React.createElement("img", {
                    src: record.sexual_desire_diagnosis_result.image_url,
                    alt: "",
                    className: "w-10 h-10 object-cover rounded border border-gray-200"
                }) : /*#__PURE__*/ React.createElement("span", {
                    className: "text-gray-400 text-[12px]"
                }, "\u672A\u8A2D\u5B9A"), /*#__PURE__*/ React.createElement(Button, {
                    type: "link",
                    size: "small",
                    className: "p-0 h-auto text-[12px]",
                    onClick: () => openDiagnosisModal(record)
                }, "\u5909\u66F4"));
            }
        }, {
            title: '作成日',
            dataIndex: 'created_at',
            key: 'created_at',
            width: 200,
            render: value => dayjs(value).format('YYYY-MM-DD HH:mm:ss')
        }];
    const buildFilterParams = values => {
        var _a, _b, _c, _d;
        const params = _objectSpread({}, values);
        if (values.ageRange) {
            const _values$ageRange$spli = values.ageRange.split('-'), _values$ageRange$spli2 = _slicedToArray(_values$ageRange$spli, 2), min = _values$ageRange$spli2[0], max = _values$ageRange$spli2[1];
            params.age_min = Number(min);
            params.age_max = Number(max);
        }
        if ((_a = values.created_date) === null || _a === void 0 ? void 0 : _a.start_date) {
            params.from_date = (_b = values.created_date) === null || _b === void 0 ? void 0 : _b.start_date.format('YYYY-MM-DD');
        }
        if ((_c = values.created_date) === null || _c === void 0 ? void 0 : _c.end_date) {
            params.to_date = (_d = values.created_date) === null || _d === void 0 ? void 0 : _d.end_date.format('YYYY-MM-DD');
        }
        return params;
    };
    const onFinish = values => updateFilter(buildFilterParams(values));
    const onReset = () => form.resetFields();
    const getLtvExportParams = recipient_email => {
        const requestParams = params;
        return {
            sex: requestParams.sex,
            email: requestParams.email,
            recipient_email,
            sort_by: requestParams.sort_by,
            order: requestParams.order
        };
    };
    const getEstimatedExportRowCount = () => { var _a, _b; return (_b = (_a = ltvExportMeta === null || ltvExportMeta === void 0 ? void 0 : ltvExportMeta.pagination) === null || _a === void 0 ? void 0 : _a.total_count) !== null && _b !== void 0 ? _b : 0; };
    const downloadCsvFile = (blob, filename) => {
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
    };
    const runDirectCsvDownload = () => __awaiter(this, void 0, void 0, function* () {
        setIsCsvExporting(true);
        try {
            const result = yield exportLTVUsersSelected(getLtvExportParams());
            if (result.type === 'email') {
                message.success(formatLtvAsyncExportMessage(result.row_count, result.email));
                return;
            }
            downloadCsvFile(result.blob, result.filename);
            message.success('CSVをダウンロードしました。');
        }
        catch (err) {
            message.error(err instanceof Error ? err.message : 'CSVのエクスポートに失敗しました。');
        }
        finally {
            setIsCsvExporting(false);
        }
    });
    const openCsvExportFlow = () => {
        if (getEstimatedExportRowCount() > ASYNC_EXPORT_MAX_ROWS) {
            setCsvEmail('');
            setIsCsvModalOpen(true);
            return;
        }
        void runDirectCsvDownload();
    };
    const closeCsvModal = () => {
        setCsvEmail('');
        setIsCsvSubmitting(false);
        setIsCsvModalOpen(false);
    };
    const handleCsvConfirm = () => __awaiter(this, void 0, void 0, function* () {
        if (!csvEmail.trim()) {
            message.error('メールアドレスを入力してください');
            return;
        }
        setIsCsvSubmitting(true);
        setIsCsvExporting(true);
        try {
            const result = yield exportLTVUsersSelected(getLtvExportParams(csvEmail));
            closeCsvModal();
            if (result.type === 'email') {
                message.success(formatLtvAsyncExportMessage(result.row_count, result.email));
                return;
            }
            message.error('メール送信でのエクスポートが開始できませんでした。しばらくしてから再度お試しください。');
        }
        catch (err) {
            message.error(err instanceof Error ? err.message : 'CSVのエクスポートに失敗しました。');
        }
        finally {
            setIsCsvSubmitting(false);
            setIsCsvExporting(false);
        }
    });
    return /*#__PURE__*/ React.createElement("div", {
        className: "user-payment"
    }, /*#__PURE__*/ React.createElement(Card, {
        className: "mb-6"
    }, /*#__PURE__*/ React.createElement(Form, {
        form: form,
        layout: "vertical",
        onFinish: onFinish
    }, /*#__PURE__*/ React.createElement("div", {
        className: "flex justify-end"
    }, /*#__PURE__*/ React.createElement(Space, {
        wrap: true,
        size: "large",
        align: "end"
    }, /*#__PURE__*/ React.createElement(Form.Item, {
        label: "\u6027\u5225",
        name: "sex"
    }, /*#__PURE__*/ React.createElement(Select, {
        allowClear: true,
        style: {
            width: 100
        }
    }, /*#__PURE__*/ React.createElement(Option, {
        value: "1"
    }, "\u7537\u6027"), /*#__PURE__*/ React.createElement(Option, {
        value: "2"
    }, "\u5973\u6027"))), /*#__PURE__*/ React.createElement(Form.Item, {
        label: "\u30E6\u30FC\u30B6\u30B9\u30C6\u30FC\u30BF\u30B9",
        name: "status"
    }, /*#__PURE__*/ React.createElement(Select, {
        allowClear: true,
        style: {
            width: 180
        },
        options: OPTION_USER_STATUS_SELECT
    })), /*#__PURE__*/ React.createElement(Form.Item, {
        label: "\u4F1A\u54E1\u30B9\u30C6\u30FC\u30BF\u30B9",
        name: "payment_confirmation"
    }, /*#__PURE__*/ React.createElement(Select, {
        allowClear: true,
        style: {
            width: 220
        },
        options: OPTION_PAYMENT_STATUS_SELECT
    })), /*#__PURE__*/ React.createElement(Form.Item, {
        label: "\u5E74\u4EE3\u5225",
        name: "ageRange"
    }, /*#__PURE__*/ React.createElement(Select, {
        allowClear: true,
        style: {
            width: 120
        }
    }, /*#__PURE__*/ React.createElement(Option, {
        value: "18-24"
    }, "18\u301C24"), /*#__PURE__*/ React.createElement(Option, {
        value: "25-34"
    }, "25\u301C34"), /*#__PURE__*/ React.createElement(Option, {
        value: "35-44"
    }, "35\u301C44"), /*#__PURE__*/ React.createElement(Option, {
        value: "45-54"
    }, "45\u301C54"), /*#__PURE__*/ React.createElement(Option, {
        value: "55-99"
    }, "55\u4EE5\u4E0A"))), /*#__PURE__*/ React.createElement(Form.Item, {
        label: "\u30E1\u30FC\u30EB",
        name: "email"
    }, /*#__PURE__*/ React.createElement(Input, {
        placeholder: "\u30E1\u30FC\u30EB",
        allowClear: true,
        style: {
            width: 260
        }
    })), /*#__PURE__*/ React.createElement(Form.Item, {
        label: "\u4F5C\u6210\u65E5",
        name: "created_date"
    }, /*#__PURE__*/ React.createElement(CreatedDateFilter, {
        onChange: value => {
            form.setFieldsValue({
                created_date: value
            });
        }
    })), /*#__PURE__*/ React.createElement(Form.Item, null, /*#__PURE__*/ React.createElement(Space, null, /*#__PURE__*/ React.createElement(Button, {
        onClick: onReset
    }, "\u30EA\u30BB\u30C3\u30C8"), /*#__PURE__*/ React.createElement(Button, {
        type: "primary",
        htmlType: "submit"
    }, "\u691C\u7D22"))))))), /*#__PURE__*/ React.createElement(Card, {
        className: "mb-4 flex justify-end"
    }), /*#__PURE__*/ React.createElement(Card, null, /*#__PURE__*/ React.createElement("div", {
        className: "flex justify-end mb-4 rounded text-white"
    }, /*#__PURE__*/ React.createElement(Button, {
        type: "primary",
        onClick: openCsvExportFlow,
        loading: isCsvExporting,
        disabled: isCsvExporting
    }, "CSV\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9")), /*#__PURE__*/ React.createElement(Table, {
        loading: isLoading || isFetching,
        columns: userColumns,
        dataSource: dataSource,
        rowKey: "id",
        onChange: handleTableChange,
        pagination: _objectSpread(_objectSpread({}, pagination), {}, {
            current: params.page
        })
    })), /*#__PURE__*/ React.createElement(Modal, {
        title: "CSV\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9",
        open: isCsvModalOpen,
        onCancel: closeCsvModal,
        onOk: handleCsvConfirm,
        confirmLoading: isCsvSubmitting,
        destroyOnClose: true
    }, /*#__PURE__*/ React.createElement(Form, {
        layout: "vertical"
    }, /*#__PURE__*/ React.createElement(Form.Item, {
        label: "\u9001\u4FE1\u5148\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9",
        required: true
    }, /*#__PURE__*/ React.createElement(Input, {
        value: csvEmail,
        onChange: e => setCsvEmail(e.target.value),
        placeholder: "example@example.com"
    })), /*#__PURE__*/ React.createElement("div", {
        className: "text-sm text-gray-500"
    }, "CSV\u306F\u30B7\u30B9\u30C6\u30E0\u306B\u3088\u308A\u81EA\u52D5\u751F\u6210\u3055\u308C\u3001\u5165\u529B\u3055\u308C\u305F\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u3078\u9001\u4FE1\u3055\u308C\u307E\u3059\u3002"))), /*#__PURE__*/ React.createElement(Modal, {
        title: diagnosisModalUser ? `診断アイコン — ユーザー #${diagnosisModalUser.id}` : '',
        open: diagnosisModalUser !== null,
        onCancel: () => setDiagnosisModalUser(null),
        onOk: () => {
            if (!diagnosisModalUser)
                return;
            diagnosisMutation.mutate({
                userId: diagnosisModalUser.id,
                resultId: diagnosisSelectValue
            });
        },
        confirmLoading: diagnosisMutation.isPending,
        destroyOnClose: true
    }, /*#__PURE__*/ React.createElement("div", {
        className: "mb-3"
    }, /*#__PURE__*/ React.createElement("span", {
        className: "text-gray-500 text-[12px] block mb-1"
    }, "\u30DE\u30B9\u30BF\u304B\u3089\u9078\u629E\uFF08\u30A2\u30AF\u30C6\u30A3\u30D6\u306E\u307F\uFF09"), /*#__PURE__*/ React.createElement(Select, {
        allowClear: true,
        placeholder: "\u672A\u8A2D\u5B9A",
        className: "w-full",
        value: diagnosisSelectValue !== null && diagnosisSelectValue !== void 0 ? diagnosisSelectValue : undefined,
        onChange: v => setDiagnosisSelectValue(typeof v === 'number' ? v : null),
        options: diagnosisOptions.map(icon => ({
            value: icon.id,
            label: icon.title
        }))
    })), /*#__PURE__*/ React.createElement(Button, {
        danger: true,
        type: "link",
        className: "p-0",
        onClick: () => setDiagnosisSelectValue(null)
    }, "\u5272\u308A\u5F53\u3066\u3092\u89E3\u9664")));
}
